import type { VxBadgeColor, VxDataTableColumn } from '@voxie/frontend-components';
import { calendarDateLabel } from '~/components/kiosk/kiosk-reassigned-numbers/rndLabels';
import type { RndRunContact, RndRunContactDecision } from '~/services/adminRndClient.types';

export const RND_RUN_CONTACTS_PER_PAGE = 50;

export type RndRunApprovalAction = 'approve' | 'deny';

export const kioskRndApprovalColumns: VxDataTableColumn<RndRunContact>[] = [
    { key: 'phone', label: 'Phone', width: 160 },
    { key: 'name', label: 'Current name', width: 220 },
    { key: 'consent_date', label: 'Consent date sent', width: 220 },
    { key: 'decision', label: 'Decision', width: 320 },
];

export const decisionLabels: Record<RndRunContactDecision, string> = {
    active: 'Left alone',
    changed: 'Changed during the run',
    reset: 'Reset',
};

export const decisionColors: Record<RndRunContactDecision, VxBadgeColor> = {
    active: 'success',
    changed: 'amber',
    reset: 'rose',
};

export const activeSinceLabel = (contact: Pick<RndRunContact, 'follow_up_date' | 'follow_up_result'>): string =>
    contact.follow_up_date === null || contact.follow_up_result === 'yes'
        ? 'active since the query'
        : `active since ${calendarDateLabel(contact.follow_up_date)}`;

export const contactNameLabel = (name: string | null): string => (name === null || name.trim() === '' ? '-' : name);
